export function isEnvironment(environment: string): environment is Environment {
    return ['dev', 'test', 'stage', 'prod', 'local'].includes(environment);
}
